import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NotificationsService } from "src/app/services/notifications.service";
import { LocalizableComponent } from "../localizable/localizable.component";

@Component({
    selector: 'notification-location-data-stale-toast',
    templateUrl: './notification-location-data-stale-toast.component.html',
    styleUrls: [
        './notification-location-data-stale-toast.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationLocationDataStaleToast extends LocalizableComponent {
  isVisible: boolean = true;

  constructor (private notificationService: NotificationsService) {
    super();
  }

  refreshNotificationLocationData() {
    this.notificationService.refreshNotificationLocationData.emit();
  }
}
